var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: "btn " + _vm.getInnerStyle + " " + _vm.getExtraInnerStyle,
      attrs: {
        type: "submit",
        id: _vm.identification,
        name: _vm.inputName,
        value: _vm.inputPlaceholder,
        disabled: _vm.dissabled
      },
      on: { click: _vm.click }
    },
    [
      _c("span", { staticClass: "inner-content-container" }, [
        _vm.iconLeft !== null
          ? _c(
              "span",
              {
                class: {
                  "btn-icon": true,
                  left: true,
                  "fa-icon-offset": _vm.faIcon
                }
              },
              [
                _vm.faIcon
                  ? _c("icon", {
                      style: { color: _vm.iconColor },
                      attrs: { name: _vm.iconLeft }
                    })
                  : _c("q-icon", {
                      style: { color: _vm.iconColor },
                      attrs: { height: _vm.iconHeight, name: _vm.iconLeft }
                    })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("span", { class: _vm.getButtonLabelClass }, [
          _vm._v("\n      " + _vm._s(_vm.$t(_vm.getPlaceHolder)) + "\n    ")
        ]),
        _vm._v(" "),
        !(!_vm.spinner || (!_vm.dataLoading && _vm.spinner))
          ? _c(
              "div",
              { staticClass: "loading-spinner" },
              [
                _c("q-icon", {
                  attrs: {
                    allowSelfUpdate: false,
                    spin: "",
                    width: _vm.getSpinnerSize,
                    name: "spinner"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.iconRight !== null
          ? _c(
              "span",
              {
                class: {
                  "btn-icon": true,
                  right: true,
                  "fa-icon-offset": _vm.faIcon
                }
              },
              [
                _vm.faIcon
                  ? _c("icon", {
                      style: { color: _vm.iconColor },
                      attrs: { name: _vm.iconRight }
                    })
                  : _c("q-icon", {
                      style: { color: _vm.iconColor },
                      attrs: { height: _vm.iconHeight, name: _vm.iconRight }
                    })
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9803cd16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9803cd16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputButton.vue
// module id = null
// module chunks = 